// extracted by mini-css-extract-plugin
export default {"container":"ze","header":"Ae","logodesktop":"Be","logomobile":"Ce","imgcontainer":"Ee","slidercontainer":"Fe","slick-slider":"Ge","slick-initialized":"He","sliderbox":"Ie","headline":"Je","mainheadline":"Ke","capitalize":"Le","desc":"Me","descitalic":"Ne","desccenter":"Oe","descborder":"Pe","subdesc":"Qe","welcomeslide":"Re","desccard":"Se","img":"Te","button":"Ue","buttonskip":"Ve","customPosition":"We"};
    if(module.hot) {
      // 1713211517693
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  